import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import BMap from 'BMap'
import { MESSAGE } from '@/util/elementHandle.js';
import BaiduMap from 'vue-baidu-map';
import { mapGetters } from 'vuex';
import { dictType } from '@/api/deviceOverview/alarm';
import dotedLineBox from '@/components/power/dottedLineBox';
import { getList, addObj, editObj, deleteObj, api, modelList } from '@/api/deviceOverview/powerStation';
import { queryDealerList } from '@/api/deviceOverview/common';
import { importExcel } from '@/api/deviceOverview/device';
import excelupdate from '@/components/excelupdate';

var moment = require('moment');

export default {
  name: 'deviceManage',
  components: {
    dotedLineBox: dotedLineBox,
    excelupdate: excelupdate
  },
  data: function data() {
    var _ref;

    return _ref = {
      isclose: true,
      mapsearch: '',
      disabled: '',
      disabledLocation: '',
      // 能否编辑经纬度
      nowTimeStr: "",
      // 实时日期时间
      deleteStationId: '',
      dialogType: '',
      // 添加或编辑对话框显示类型
      installDate: '',
      // 安装时间
      ifAdd: '',
      // 添加或编辑表单类型
      DialogVisible: false,
      // 添加或编辑表单显示
      deleteDialogVisible: false,
      //删除确认显示
      excelDialogVisible: false,
      // excel表导入弹窗
      excelData: [],
      // excel表格数据
      rules: {
        gatewayName: [{
          required: true,
          message: '请输入网关名称',
          trigger: 'blur'
        }],
        sn: [{
          required: true,
          message: '请输入网关sn',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入网关密码',
          trigger: 'blur'
        }],
        deviceModel: [{
          required: true,
          message: '请选择设备类型',
          trigger: 'change'
        }],
        deviceNo: [{
          required: true,
          message: '请输入设备出厂编号',
          trigger: 'blur'
        }],
        sawModel: [{
          required: true,
          message: '请输入设备型号',
          trigger: 'blur'
        }]
      },
      form: {
        // 添加或编辑 表单
        installTime: '',
        address: '',
        //详细位置
        city: '',
        //城市
        installCapacity: '',
        //装机容量
        location: {
          lat: null,
          lon: null
        },
        //位置
        deviceNo: '',
        //设备出厂编号
        sawModel: '',
        //设备型号
        province: '',
        //省份
        gatewayName: '',
        //网关名称
        sn: '',
        //sn
        password: '',
        //网关密码
        type: '',
        // 设备类型
        userName: '',
        //联系人
        userPhone: '',
        // 联系电话
        customerName: '',
        // 客户名称
        productionTime: '',
        //出厂日期
        expirationTime: '',
        // 质保到期
        gatewayId: ''
      },
      typeList: [],
      formLabelWidth: '110px',
      pointChoseType: 'chose',
      // 哪种选点方式---1、地图上选点(chose) 2、关键词搜索(search)
      keyWordObj: null,
      // 关键词检索变量
      map: null,
      // 地图实例
      prePoint: {},
      // 地图搜索关键字储存上一个点坐标
      query: {
        address: '',
        name: '',
        pageIndex: 1,
        pageSize: 10
      },
      tableData: [],
      multipleSelection: [],
      delList: [],
      editVisible: false,
      pageTotal: 0
    }, _defineProperty(_ref, "form", {}), _defineProperty(_ref, "idx", -1), _defineProperty(_ref, "id", -1), _defineProperty(_ref, "gw_add", true), _defineProperty(_ref, "gw_edit", true), _defineProperty(_ref, "gw_del", true), _defineProperty(_ref, "oneTitle", '网关信息'), _defineProperty(_ref, "deviceList", []), _defineProperty(_ref, "gatewayList", []), _defineProperty(_ref, "deviceStatus", ''), _defineProperty(_ref, "gatewayStatus", ''), _defineProperty(_ref, "dealerOptions", []), _defineProperty(_ref, "dealer", ''), _defineProperty(_ref, "deviceNoInput", ''), _defineProperty(_ref, "sawModelInput", ''), _ref;
  },
  mounted: function mounted() {},
  created: function created() {
    this.getPage(); // this.queryList()

    this.queryDeviceList(); // this.getDealerList()

    console.log(this.permissions['gw_add'], '----permissions'); // 显示实时日期时间

    this.nowTimeStr = moment().format("YYYY-MM-DD"); // this.permissions['gw_add'] && (this.gw_add = this.permissions['gw_add'])
    // this.permissions['gw_edit'] && (this.gw_edit = this.permissions['gw_edit'])
    // this.permissions['gw_del'] && (this.gw_del = this.permissions['gw_del'])
  },
  methods: {
    beforclose: function beforclose() {
      this.$refs.form.resetFields();
      this.DialogVisible = false;
    },
    closedialog: function closedialog() {
      this.$refs.form.resetFields();
      this.DialogVisible = false;
    },

    /* 经销商列表
     */
    getDealerList: function getDealerList() {
      var _this2 = this;

      queryDealerList().then(function (res) {
        if (res.data.code === 200) {
          if (!res.data.data) {
            return;
          }

          _this2.dealerOptions = res.data.data;

          _this2.dealerOptions.unshift({
            id: '',
            realName: "全部"
          });
        } else {
          MESSAGE({
            text: res.data.msg,
            type: 'error'
          });
        }
      });
    },
    queryList: function queryList() {
      var _this3 = this;

      dictType('device_state').then(function (res) {
        if (res.data.code === 200) {
          _this3.deviceList = [];
          _this3.deviceList = res.data.data;

          _this3.deviceList.unshift({
            description: "设备状态",
            dictValue: "全部",
            dictKey: ""
          });
        } else {
          _this3.$message.error(res.data.msg);

          return;
        }
      });
    },
    queryDeviceList: function queryDeviceList() {
      var _this4 = this;

      modelList().then(function (res) {
        console.log(res, 'res---');

        if (res.data.code === 200) {
          _this4.typeList = res.data.data;
        } else {
          MESSAGE({
            text: res.data.msg,
            type: 'error'
          });
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.query.pageSize = val;
      this.getPage();
    },
    handlePageChange: function handlePageChange(val) {
      this.query.pageIndex = val;
      this.getPage();
    },
    // 操作相关
    // 添加
    addHandle: function addHandle() {
      this.dialogType = '添加设备';
      this.disabled = false; // 启用其余输入

      this.DialogVisible = true; // 显示表单

      this.disabledLocation = false; // 启用编辑经纬度输入

      this.form = {
        // 添加或编辑 表单
        address: '',
        //详细位置
        city: '',
        //城市
        installCapacity: '',
        //装机容量
        location: {
          lat: null,
          lon: null
        },
        //位置
        deviceNo: '',
        sawModel: '',
        province: '',
        //省份
        gatewayName: '',
        //网关名称
        sn: '',
        //sn
        password: '',
        //网关密码
        deviceModel: '',
        // 设备类型
        userName: '',
        //联系人
        userPhone: '',
        // 联系电话
        customerName: '',
        // 客户名称
        productionTime: this.nowTimeStr,
        //出厂日期
        expirationTime: this.nowTimeStr,
        // 质保到期
        installTime: this.nowTimeStr //安装时间

      }, this.keyWordObj = null, this.mapselectpoint();
    },
    // 查看
    viewHandle: function viewHandle(row) {
      this.dialogType = '查看设备';
      this.disabled = true; // 禁用其余输入

      this.DialogVisible = true; // 显示表单

      this.disabledLocation = true; // 禁用编辑经纬度输入

      this.form = row;
      this.form.location = JSON.parse(row.location);
      this.form.deviceModel = row.deviceModel + '';
      this.mapselectpoint();
    },
    // 编辑
    editHandle: function editHandle(row) {
      this.dialogType = '编辑设备';
      this.disabled = false; // 启用其余输入

      this.DialogVisible = true; // 显示表单

      this.disabledLocation = true; // 禁用编辑经纬度输入

      this.form = row;
      this.form.location = JSON.parse(row.location);
      this.form.deviceModel = row.deviceModel + '';
      this.mapselectpoint();
    },
    // 删除
    deleteHandle: function deleteHandle(row) {
      this.deleteDialogVisible = true;
      this.deleteStationId = row.gatewayId;
    },
    // 地图初始化
    mapinit: function mapinit() {
      // 创建地图实例
      this.map = new BMap.Map('StationMap'); // 设置中心点和缩放比例
      // this.map.centerAndZoom(new BMap.Point(116.404, 39.915), 11)

      this.prePoint = this.form.location;

      if (this.form.location.lon == null || this.form.location.lon == '') {
        this.map.centerAndZoom('杭州', 11);
      } else {
        this.map.centerAndZoom(new BMap.Point(this.form.location.lon, this.form.location.lat), 11);
        var point = new BMap.Point(this.form.location.lon, this.form.location.lat);
        var myIcon = new BMap.Icon(require('@/assets/img/map_icon.png'), new BMap.Size(47, 49));
        var marker = new BMap.Marker(point, {
          icon: myIcon
        }); // 创建标注

        this.map.addOverlay(marker); // 将标注添加到地图中
      } // 修改地图主题样式


      this.map.setMapStyle({
        style: this.currentMayStyle
      }); // 开启鼠标滚轮缩放

      this.map.enableScrollWheelZoom(true);
    },
    // 选择-地图上选点
    mapselectpoint: function mapselectpoint() {
      // 修改选点方式
      this.pointChoseType = 'chose'; // 1、地图上选点(chose) 2、关键词搜索(search)
      // 清除地图

      this.map = null; // 清除 地点关键词

      this.form.locationKeyWord = ''; // 地点关键词
      // 设置地图

      this.$nextTick(function () {
        // 百度地图是必须让它在页面加载完成后显示（生命周期mounted），但是由于element的对话框（el-dialog）是基于v-if这个功能。所以，应该在dom加载完后再初始化地图
        // 地图初始化
        this.mapinit(); // 添加点击地图监听事件---点击地图后添加标注点

        if (this.dialogType != '查看设备') {
          this.map.addEventListener('click', function (e) {
            // console.log(e)
            // 清除标注点
            this.map.clearOverlays(); // 添加标注点

            var point = new BMap.Point(e.point.lng, e.point.lat); // 创建点

            var myIconOn = new BMap.Icon(require("@/assets/img/map_icon.png"), new BMap.Size(47, 49));
            var marker = new BMap.Marker(point, {
              icon: myIconOn
            }); // 创建标注
            // var marker = new BMap.Marker(point)  // 创建标注

            this.map.addOverlay(marker); // 将标注添加到地图中
            // 修改form表单内容
            // 设备坐标

            this.form.location = {
              'lat': e.point.lat.toFixed(6),
              'lon': e.point.lng.toFixed(6)
            };
            var geoc = new BMap.Geocoder(); // 用于获取用户的地址解析
            // 地址解析

            geoc.getLocation(e.point, function (rs) {
              var addComp = rs.addressComponents; // 设备所在省份

              this.form.province = addComp.province; // 设备所在城市

              this.form.city = addComp.city;
            }.bind(this));
          }.bind(this));
        }
      }.bind(this));
    },
    // 选择-关键词搜索
    mapkeyword: function mapkeyword() {
      console.log(1); // 修改选点方式
      // debugger

      this.pointChoseType = 'search'; // 1、地图上选点(chose) 2、关键词搜索(search)
      // 清除地图

      this.map = null; // 清除 地点关键词

      this.form.locationKeyWord = ''; // 地点关键词
      // 设置地图

      this.$nextTick(function () {
        // 百度地图是必须让它在页面加载完成后显示（生命周期mounted），但是由于element的对话框（el-dialog）是基于v-if这个功能。所以，应该在dom加载完后再初始化地图
        // 地图初始化
        this.mapinit();

        var _this = this; // 关键词检索


        var gjcOptions = {
          // 结果呈现设置
          renderOptions: {
            map: this.map
          },
          // // 标注添加完成后的回调函数
          // onMarkersSet: function () {
          //   console.log('onMarkersSet')
          // },
          // 标注气泡内容创建后的回调函数---点击不同气泡会触发
          onInfoHtmlSet: function onInfoHtmlSet(res) {
            // 修改form表单内容
            // 设备坐标
            _this.form.location = {
              'lat': res.point.lat.toFixed(6),
              'lon': res.point.lng.toFixed(6)
            }; // 设备所在省份

            _this.form.province = res.province; // 设备所在城市

            _this.form.city = res.city;
          } // // 结果列表添加完成后的回调函数
          // onResultsHtmlSet: function () {
          //   console.log('onResultsHtmlSet')
          // },
          // // 检索完成后的回调函数
          // onSearchComplete: function (results) {
          //   console.log(results)
          // }

        }; // console.log(gjcOptions)

        this.keyWordObj = new BMap.LocalSearch(this.map, gjcOptions); // 用于位置检索、周边检索和范围检索。

        var allOverlay = this.map.getOverlays();
        console.log(allOverlay); // this.keyWordObj.search("景点")
        // 添加点击地图监听事件---点击地图后添加标注点

        this.map.addEventListener('click', function (e) {
          // console.log(e)
          // console.log(this.prePoint)
          // 清除标注点
          // this.map.clearOverlays(marker)
          var allOverlay = this.map.getOverlays(); // console.log(allOverlay)
          // console.log(this.prePoint)

          for (var i = 0; i < allOverlay.length; i++) {
            if (allOverlay[i].point && allOverlay[i].point.lng == this.prePoint.lon && allOverlay[i].point.lat == this.prePoint.lat) {
              this.map.removeOverlay(allOverlay[i]); // return false;
            }
          }

          this.mapsearch = ''; // 添加标注点

          var point = new BMap.Point(e.point.lng, e.point.lat); // 创建点

          var myIconOn = new BMap.Icon(require("@/assets/img/map_icon.png"), new BMap.Size(47, 49));
          var marker = new BMap.Marker(point, {
            icon: myIconOn
          }); // 创建标注
          // var marker = new BMap.Marker(point)  // 创建标注

          this.map.addOverlay(marker); // 将标注添加到地图中
          // 修改form表单内容
          // 设备坐标

          this.form.location = {
            'lat': e.point.lat.toFixed(6),
            'lon': e.point.lng.toFixed(6)
          };
          this.prePoint = {
            'lat': e.point.lat,
            'lon': e.point.lng
          };
          var geoc = new BMap.Geocoder(); // 用于获取用户的地址解析
          // 地址解析

          geoc.getLocation(e.point, function (rs) {
            var addComp = rs.addressComponents; // 设备所在省份

            this.form.province = addComp.province; // 设备所在城市

            this.form.city = addComp.city;
          }.bind(this));
        }.bind(this));
      }.bind(this));
    },
    // 点击地点的搜索---关键词检索
    mapKeyWord: function mapKeyWord() {
      console.log(2);
      this.keyWordObj.search(this.mapsearch);
    },
    search: function search() {
      this.query.pageIndex = 1;
      this.getPage();
    },
    // api相关
    // 查询列表数据
    getPage: function getPage() {
      var _this5 = this;

      var obj = {
        current: this.query.pageIndex,
        size: this.query.pageSize,
        gatewayName: this.query.name,
        onlineFlag: this.gatewayStatus,
        deviceState: this.deviceStatus,
        deviceNo: this.deviceNoInput,
        sawModel: this.sawModelInput
      };
      this.dealer && (obj.dealerId = this.dealer);
      getList(obj).then(function (response) {
        console.log(response);
        var data = response.data.data; // debugger

        if (response.data.code === 200) {
          data.records.map(function (item, index) {
            // item.location = JSON.parse(item.location)
            item.id = index + 1;
          });
          _this5.tableData = data.records;
        }

        _this5.pageTotal = data.total;
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 添加确认
    addBtn: function addBtn() {
      var _this6 = this;

      this.$refs['form'].validate(function (valid) {
        console.log(valid);

        if (valid) {
          var _this6$form = _this6.form,
              gatewayName = _this6$form.gatewayName,
              deviceModel = _this6$form.deviceModel,
              sn = _this6$form.sn,
              password = _this6$form.password,
              province = _this6$form.province,
              city = _this6$form.city,
              deviceNo = _this6$form.deviceNo,
              sawModel = _this6$form.sawModel,
              address = _this6$form.address,
              userName = _this6$form.userName,
              userPhone = _this6$form.userPhone,
              customerName = _this6$form.customerName,
              installTime = _this6$form.installTime,
              productionTime = _this6$form.productionTime,
              expirationTime = _this6$form.expirationTime;
          var param = {
            gatewayName: gatewayName,
            deviceModel: deviceModel,
            sn: sn,
            password: password,
            province: province,
            deviceNo: deviceNo,
            sawModel: sawModel,
            city: city,
            address: address,
            userName: userName,
            userPhone: userPhone,
            customerName: customerName,
            installTime: installTime,
            productionTime: productionTime,
            expirationTime: expirationTime,
            location: JSON.stringify(_this6.form.location)
          };
          console.log(param);
          addObj(param).then(function (response) {
            if (response.data.code === 200) {
              MESSAGE({
                text: '添加成功',
                type: 'success'
              });
              _this6.DialogVisible = false;
              _this6.query.pageIndex = 1;
              console.log(response);

              _this6.getPage();
            } else {
              MESSAGE({
                text: '添加失败',
                type: 'error'
              });
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return false;
        }
      });
    },
    // 编辑确认
    editBtn: function editBtn() {
      var _this7 = this;

      this.$refs['form'].validate(function (valid) {
        console.log(valid);

        if (valid) {
          var _this7$form = _this7.form,
              gatewayName = _this7$form.gatewayName,
              deviceModel = _this7$form.deviceModel,
              sn = _this7$form.sn,
              password = _this7$form.password,
              deviceNo = _this7$form.deviceNo,
              sawModel = _this7$form.sawModel,
              province = _this7$form.province,
              city = _this7$form.city,
              address = _this7$form.address,
              userName = _this7$form.userName,
              userPhone = _this7$form.userPhone,
              customerName = _this7$form.customerName,
              installTime = _this7$form.installTime,
              productionTime = _this7$form.productionTime,
              expirationTime = _this7$form.expirationTime,
              gatewayId = _this7$form.gatewayId;
          var param = {
            gatewayId: gatewayId,
            gatewayName: gatewayName,
            deviceModel: deviceModel,
            deviceNo: deviceNo,
            sawModel: sawModel,
            sn: sn,
            password: password,
            province: province,
            city: city,
            userName: userName,
            address: address,
            userPhone: userPhone,
            customerName: customerName,
            installTime: installTime,
            productionTime: productionTime,
            expirationTime: expirationTime,
            location: JSON.stringify(_this7.form.location)
          };
          console.log(param);
          editObj(param).then(function (response) {
            if (response.data.code === 200) {
              MESSAGE({
                text: '修改成功',
                type: 'success'
              });
              _this7.DialogVisible = false;
              console.log(response);

              _this7.getPage();
            } else {
              MESSAGE({
                text: '修改失败',
                type: 'error'
              });
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return false;
        }
      });
    },
    // 删除确认
    deleteBtn: function deleteBtn() {
      var _this8 = this;

      var param = {
        id: this.deleteStationId
      };
      deleteObj(param).then(function (response) {
        if (response.data.code === 200) {
          MESSAGE({
            text: '删除成功',
            type: 'success'
          });
          _this8.deleteDialogVisible = false; // console.log(response);

          _this8.getPage();
        } else {
          MESSAGE({
            text: '删除失败',
            type: 'error'
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 导入EXCEL相关
    addexcel: function addexcel() {
      this.excelDialogVisible = true;
    },
    // 处理excel数据
    childByValue: function childByValue(val) {
      console.log(val);
      var arr = [];
      val.map(function (item, index) {
        var obj = {};
        obj.gatewayName = JSON.parse(JSON.stringify(item))["设备名称"];
        obj.deviceModel = JSON.parse(JSON.stringify(item))["设备型号"];
        obj.sn = JSON.parse(JSON.stringify(item))["SN"];
        obj.password = JSON.parse(JSON.stringify(item))["密码"];
        obj.userName = JSON.parse(JSON.stringify(item))["联系人"];
        obj.userPhone = JSON.parse(JSON.stringify(item))["联系电话"];
        obj.customerName = JSON.parse(JSON.stringify(item))["供应商名称"];
        obj.productionTime = JSON.parse(JSON.stringify(item))["采购日期"];
        obj.expirationTime = JSON.parse(JSON.stringify(item))["质保日期"];
        obj.installTime = JSON.parse(JSON.stringify(item))["安装时间"];
        obj.province = JSON.parse(JSON.stringify(item))["省份"];
        obj.city = JSON.parse(JSON.stringify(item))["地市"];
        obj.address = JSON.parse(JSON.stringify(item))["详细地址"];
        arr[index] = obj;
      });
      this.excelData = arr;
      console.log(this.excelData);
    },
    // 上传excel
    UpData: function UpData() {
      var _this9 = this;

      importExcel(this.excelData).then(function (res) {
        if (res.code === '0') {
          _this9.close(0);

          _this9.$message({
            message: '上传成功',
            type: 'success'
          });
        } else {
          _this9.$message.error('上传失败');
        }
      });
    }
  },
  computed: _objectSpread({}, mapGetters(['permissions']))
};